import { getCurrentOpenedChatId } from './helpers';
import { ERouteActionTypes } from '../../actions/route';
import { TAppState } from '../../types/appState';
import { TReduxActions } from '../../types/redux/actions';

export function routeReducer(state: TAppState, action: TReduxActions): TAppState {
  switch (action.type) {
    case ERouteActionTypes.SetRoute:
      const notClearCurrentOpenedChatId = state.chatList.notClearCurrentOpenedChatId;
      const currentOpenedChatId = state.chatWindow.currentOpenedChatId;
      const currentRoute = state.chatList.currentRoute;

      return {
        ...state,
        chatList: {
          ...state.chatList,
          currentRoute: action.payload.route,
          removedFromArchiveChatId: !action.payload.cleanRemovedFromArchiveChatId
            ? state.chatList.removedFromArchiveChatId
            : '',
          removedFromSpamChatId: !action.payload.cleanRemovedFromSpamChatId ? state.chatList.removedFromSpamChatId : '',
        },
        chatWindow: {
          ...state.chatWindow,
          currentOpenedChatId: getCurrentOpenedChatId(
            currentRoute,
            action.payload.route,
            notClearCurrentOpenedChatId,
            currentOpenedChatId,
          ),
        },
      };

    default:
      return state;
  }
}
